import React from 'react';

import { twMerge } from 'tailwind-merge';
import { useLocation } from 'wouter';

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  coin: any;
  onConfirm: () => Promise<void>;
  title?: string;
}

const ConfirmCancelModal: React.FC<ModalProps> = ({
  isOpen,
  coin,
  closeModal,
  onConfirm,
  title = 'Confirm Cancel Setup Strategy!',
}) => {
  const [, setLocation] = useLocation();
  const {
    name = '',
    token = '',
    symbol = '',
    uri = '',
  } = coin || { token: '', symbol: '', name: '', uri: '' };

  return (
    <div
      className={twMerge(
        'fixed w-screen inset-0 flex items-center justify-center z-50 backdrop-blur-md',
        !isOpen && 'hidden',
      )}
    >
      <div className="flex w-full max-w-[480px] flex-col p-6 rounded-lg gap-3 bg-[#13141D] relative justify-center items-center">
        <button
          onClick={() => closeModal()}
          className="absolute top-6 right-6 text-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="mt-6 text-[18px] text-[#E8E9EE]">{title}</div>
        <div className="flex items-center justify-center w-full gap-2 flex-wrap mt-2 mb-8">
          {uri && (
            <img
              src={uri}
              alt="coinImg"
              className="w-14 h-14 rounded-full border border-[#9192A0]"
            />
          )}

          <div className="">
            <span className="text-[18px] font-semibold">{name}</span>
            <br />
            <span className="uppercase text-[#9192A0] text-[12px]">
              ${symbol || '--'}
            </span>
            {/* <span className="mt-6 text-[#9192A0] text-[12px] font-semibold text-wrap break-all">
              Contract: {token || '--'}
            </span> */}
          </div>
        </div>

        <div className="flex gap-2 flex-wrap w-full items-center justify-center">
          <button
            onClick={closeModal}
            className="flex-1 p-2 text-center uppercase disabled:opacity-75 w-full disabled:cursor-not-allowed rounded bg-[rgba(255,255,255,0.25)] cursor-pointer"
          >
            Close
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 text-center bg-white text-[#080A14] disabled:opacity-75 w-full disabled:cursor-not-allowed uppercase p-2 rounded cursor-pointer"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCancelModal;
